import { UnsubscribeEmailToNewsletterDocument } from '../../queries/UnsubscribeEmailToNewsletter.gql'
import { useMutation } from './useMutation'

const useUnsubscribeEmailToNewsletter = () => {
  const [mutation, {loading}] = useMutation(UnsubscribeEmailToNewsletterDocument)

  const unsubscribeEmailToNewsletter = (email: string) =>
    mutation({
      variables: {
        email,
      },
    })

  return {unsubscribeEmailToNewsletter, loading}
}

export default useUnsubscribeEmailToNewsletter
